import React from 'react';
import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  RoadmapDeliverablePostSelectionNextUpActionsStepTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/ScenarioSelectionRedefinedPostSelectionNextUpActionStepPicker/Template/RoadmapDeliverablePostSelectionNextUpActionsStepTemplate';
import {
  ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/ScenarioSelectionRedefinedPostSelectionNextUpActionStepPicker/Template/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate';
import { GuidedHouseholdReviewPostSelectionNextUpActionsStepTemplate } from './Template/GuidedHouseholdReviewPostSelectionNextUpActionsStepTemplate';

const ScenarioSelectionRedefinedPostSelectionNextUpActionStepPicker = ({ resource }) => {
  const { pageContentResource } = usePageContentContext();
  return pick(pageContentResource, {
    [fr.relationships.guidedHouseholdReviewLayout.name]: <GuidedHouseholdReviewPostSelectionNextUpActionsStepTemplate resource={resource} />,
    [fr.relationships.roadmapDeliverableLayout.name]: <RoadmapDeliverablePostSelectionNextUpActionsStepTemplate resource={resource} />,
  }, <ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate resource={resource} />);
};


export default ScenarioSelectionRedefinedPostSelectionNextUpActionStepPicker;
